/**
 * layers.tsx
 */
import Screen from '@screen';
import styled from 'styled-components';
import { AxisPreset } from './types';
import { DURATION } from '@shared/types/constants/animations';

const axisTransition = ({
  duration = DURATION.RAILS_WRAPPER,
  delay = 0,
  easing = 'ease-out',
  extraTransition,
}: AxisPreset & { collapse?: boolean }) =>
  [`transform ${duration}ms ${easing} ${delay}ms`, extraTransition]
    .filter(Boolean)
    .join(', ');

export const HorizontalLayer = styled.div<{
  axis: AxisPreset & { collapse?: boolean };
}>`
  transform: translateX(
    ${({ axis: { collapse, offset } }) =>
      Screen.widthRatio * (collapse ? offset.COLLAPSED : offset.EXPANDED)}px
  );
  transition: ${({ axis }) => axisTransition(axis)};
`;

export const VerticalLayer = styled.div<{
  axis: AxisPreset & { collapse?: boolean };
}>`
  transform: translateY(
    ${({ axis: { collapse, offset } }) =>
      Screen.widthRatio * (collapse ? offset.COLLAPSED : offset.EXPANDED)}px
  );
  transition: ${({ axis }) => axisTransition(axis)};
`;
